import { useMutation } from '@tanstack/react-query';
import { apiClient as api } from '@/lib/api';

export interface ImportReport {
  total: number;
  imported: number;
  skipped: number;
  errors: Array<{ rowIndex: number; reason: string }>;
}

export function useImportVehicles() {
  return useMutation({
    mutationFn: async (data: { rows: any[]; fileName?: string; projectCode?: string }) => {
      const r = await api.post('/api/v1/imports/vehicles', data);
      return r.data as ImportReport;
    },
  });
}

export function useImportDrivers() {
  return useMutation({
    mutationFn: async (data: { rows: any[]; fileName?: string; projectCode?: string }) => {
      const r = await api.post('/api/v1/imports/drivers', data);
      return r.data as ImportReport;
    },
  });
}

export function useAutoMapDelegates() {
  return useMutation({
    mutationFn: async () => {
      const r = await api.post('/api/v1/imports/delegate-mapping/auto');
      return r.data as { matched: number; unmatched: string[]; backfilled: number };
    },
  });
}
